// project-imports
import { deleteRequest, getRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - NOTES ||============================== //

export async function handleNotes(action: APIAction) {
  switch (action.method) {
    case 'create':
      return postRequest('/notes', action.data);
    case 'read':
      return getRequest(`/notes?customer-id=${action.data.customerId}&agent-id=${action.data.agentId}`);
    case 'update':
      return putRequest(`/notes/${action.id}`, action.data);
    case 'delete':
      return deleteRequest(`/notes/${action.id}`);
    default:
      console.info('[ApiManager > handleApiAction > handleNotes] - Unknown method');
      break;
  }
}
